import {Routes} from '@angular/router';
import {CoreRoutes} from './modules/core/routes/core';
import {ChangePasswordGuard} from './modules/core/guards/change-password';
import {LoggedInGuard} from './modules/core/guards/logged-in';
import {StartPageComponent} from './containers/start-page';
import { UserAgreementGuard } from 'app/modules/core/guards/user-agreement';
import { AboutUsComponent } from 'app/modules/irar/components/about-us';
import { AbbreviationComponent } from 'app/modules/irar/components/abbreviation';
import { IrarRoutes } from './modules/irar/routes/irar';
import { SuperAdminGuard } from './modules/core/guards/super-admin';
import { CoreAdminContainerComponent } from './containers/core-admin';
import { LoginPageComponent } from 'app/modules/core/containers/login';
import { ForgotPasswordPageComponent } from 'app/modules/core/containers/forgot-password';
import { ChangePasswordPageComponent } from 'app/modules/core/containers/change-password';
import {AdminGuard} from './modules/core/guards/admin';

export const routes: Routes = [
  ...IrarRoutes,
  ...[{
      path: '',
      component: StartPageComponent,
      canActivate: [],
      data: {
        breadcrumb: '',
        title: 'Home'
      }
    },
    {
      path: 'core',
      component: CoreAdminContainerComponent,
      canActivate: [AdminGuard],
      children: CoreRoutes
    },
    { path: 'login',
      component: LoginPageComponent,
      data: {
        breadcrumb: 'Login'
      }
    },
    { path: 'forgotpassword',
      component: ForgotPasswordPageComponent,
      data: {
        breadcrumb: 'Forgot Password'
      }
    },
    { path: 'changepassword',
      component: ChangePasswordPageComponent,
      canActivate: [LoggedInGuard, UserAgreementGuard],
      data: {
        breadcrumb: 'Change Password'
      }
    }

  ],
  ...[{
    path: '',
    redirectTo: '/',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: '/',
    pathMatch: 'full'
  }
]];



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/app-routes.ts